import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function AICampManagement() {
  const [tab, setTab] = useState('enrollments')
  const [enrollments, setEnrollments] = useState([])
  const [animations, setAnimations] = useState([])
  const [loading, setLoading] = useState(true)
  const [stats, setStats] = useState({})

  useEffect(() => {
    loadEnrollments()
    loadAnimations()
  }, [])

  const loadEnrollments = () => {
    fetch(`${API}/ai-camp/enrollments`)
      .then(r => r.json())
      .then(d => {
        if (d.success) {
          setEnrollments(d.data || [])
          setStats(d.stats || {})
        }
      })
      .finally(() => setLoading(false))
  }

  const loadAnimations = () => {
    fetch(`${API}/ai-camp/animations`)
      .then(r => r.json())
      .then(d => {
        if (d.success) setAnimations(d.data || [])
      })
  }

  const getStatusBadge = (status) => {
    const map = {
      active:    { bg: '#e6f4ff', color: '#1890ff', text: '学习中' },
      completed: { bg: '#f6ffed', color: '#52c41a', text: '已完成' },
      pending:   { bg: '#fffbe6', color: '#faad14', text: '待制作' },
      submitted: { bg: '#f9f0ff', color: '#722ed1', text: '已提交' },
    }
    const s = map[status] || { bg: '#f5f5f5', color: '#999', text: status }
    return <span style={{ padding: '2px 10px', borderRadius: 10, fontSize: 12, background: s.bg, color: s.color }}>{s.text}</span>
  }

  const getCareerIcon = (career) => {
    const icons = {
      '医生': '👨‍⚕️', '消防员': '👨‍🚒', '科学家': '🔬', '画家': '🎨',
      '飞行员': '✈️', '老师': '👨‍🏫', '厨师': '👨‍🍳', '建筑师': '🏗️', '记者': '📰', '驯兽师': '🐬'
    }
    return icons[career] || '🎭'
  }

  const getProductName = (productId) => {
    const names = { 'ACO01': 'AI创作营·基础', 'ACO02': 'AI创作营·进阶班' }
    return names[productId] || productId
  }

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>🤖 AI创作营管理</h2>
      <p style={{ color: '#666', marginBottom: 20 }}>管理AI创作营学员报名、作业提交和动画制作</p>

      {/* 统计卡片 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        <div style={card}>
          <div style={{ color: '#999', fontSize: 12 }}>总报名人数</div>
          <div style={{ fontSize: 28, color: '#1890ff', fontWeight: 600 }}>{stats.total || 0}</div>
        </div>
        <div style={card}>
          <div style={{ color: '#999', fontSize: 12 }}>学习中</div>
          <div style={{ fontSize: 28, color: '#faad14', fontWeight: 600 }}>{stats.active_count || 0}</div>
        </div>
        <div style={card}>
          <div style={{ color: '#999', fontSize: 12 }}>已完成</div>
          <div style={{ fontSize: 28, color: '#52c41a', fontWeight: 600 }}>{stats.completed_count || 0}</div>
        </div>
        <div style={card}>
          <div style={{ color: '#999', fontSize: 12 }}>动画订单</div>
          <div style={{ fontSize: 28, color: '#722ed1', fontWeight: 600 }}>{animations.length}</div>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 20 }}>
        <button onClick={() => setTab('enrollments')}
          style={{ padding: '10px 24px', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14, background: tab === 'enrollments' ? '#1890ff' : '#f5f5f5', color: tab === 'enrollments' ? '#fff' : '#666' }}>
          📚 学员报名
        </button>
        <button onClick={() => setTab('animations')}
          style={{ padding: '10px 24px', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14, background: tab === 'animations' ? '#1890ff' : '#f5f5f5', color: tab === 'animations' ? '#fff' : '#666' }}>
          🎬 动画订单
        </button>
      </div>

      {/* 学员报名列表 */}
      {tab === 'enrollments' && (
        <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
          {loading ? (
            <div style={{ padding: 40, textAlign: 'center', color: '#666' }}>加载中...</div>
          ) : enrollments.length === 0 ? (
            <div style={{ padding: 40, textAlign: 'center', color: '#666' }}>暂无报名记录</div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#fafafa' }}>
                  <th style={th}>学员</th>
                  <th style={th}>课程</th>
                  <th style={th}>机构</th>
                  <th style={th}>完成课时</th>
                  <th style={th}>状态</th>
                  <th style={th}>报名时间</th>
                </tr>
              </thead>
              <tbody>
                {enrollments.map(e => (
                  <tr key={e.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={td}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <span style={{ fontSize: 24 }}>{e.child_avatar ? '👶' : '👦'}</span>
                        <span style={{ fontWeight: 500 }}>{e.child_name || '未知'}</span>
                      </div>
                    </td>
                    <td style={td}>
                      <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 12, background: '#e6f4ff', color: '#1890ff' }}>
                        {getProductName(e.product_id)}
                      </span>
                    </td>
                    <td style={td}>{e.institution_name || '-'}</td>
                    <td style={td}>
                      <span style={{ color: '#52c41a', fontWeight: 600 }}>{e.completed_lessons || 0}</span> 课时
                    </td>
                    <td style={td}>{getStatusBadge(e.status)}</td>
                    <td style={{ ...td, color: '#999', fontSize: 12 }}>{e.created_at?.slice(0, 10)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* 动画订单列表 */}
      {tab === 'animations' && (
        <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
          {animations.length === 0 ? (
            <div style={{ padding: 40, textAlign: 'center', color: '#666' }}>暂无动画订单</div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#fafafa' }}>
                  <th style={th}>学员</th>
                  <th style={th}>职业</th>
                  <th style={th}>课程</th>
                  <th style={th}>状态</th>
                  <th style={th}>提交时间</th>
                  <th style={th}>操作</th>
                </tr>
              </thead>
              <tbody>
                {animations.map(a => (
                  <tr key={a.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={td}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <span style={{ fontSize: 24 }}>{getCareerIcon(a.career)}</span>
                        <span style={{ fontWeight: 500 }}>{a.childName}</span>
                      </div>
                    </td>
                    <td style={td}>{a.career}</td>
                    <td style={td}>
                      <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 12, background: '#f6ffed', color: '#52c41a' }}>
                        {a.product}
                      </span>
                    </td>
                    <td style={td}>{getStatusBadge(a.status)}</td>
                    <td style={{ ...td, color: '#999', fontSize: 12 }}>{a.submittedAt?.slice(0, 10) || '-'}</td>
                    <td style={td}>
                      {a.status === 'submitted' && (
                        <button style={{ ...btn, background: '#1890ff', color: '#fff' }}>接单</button>
                      )}
                      {a.status === 'completed' && a.videoUrl && (
                        <button style={{ ...btn, background: '#52c41a', color: '#fff' }}>查看视频</button>
                      )}
                      <button style={{ ...btn, background: '#f5f5f5', color: '#666', marginLeft: 8 }}>详情</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* 说明 */}
      <div style={{ marginTop: 20, background: '#fff', borderRadius: 8, padding: 16 }}>
        <h4 style={{ marginBottom: 8 }}>📋 AI创作营流程</h4>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, fontSize: 13, color: '#666' }}>
          <div style={{ padding: 12, background: '#f6ffed', borderRadius: 8, textAlign: 'center' }}>
            <div style={{ fontSize: 24, marginBottom: 4 }}>📝</div>
            <div style={{ fontWeight: 500 }}>1. 报名课程</div>
            <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>学员在小程序报名</div>
          </div>
          <div style={{ padding: 12, background: '#e6f4ff', borderRadius: 8, textAlign: 'center' }}>
            <div style={{ fontSize: 24, marginBottom: 4 }}>📚</div>
            <div style={{ fontWeight: 500 }}>2. 完成课时</div>
            <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>学习职业故事/创作</div>
          </div>
          <div style={{ padding: 12, background: '#fffbe6', borderRadius: 8, textAlign: 'center' }}>
            <div style={{ fontSize: 24, marginBottom: 4 }}>🎨</div>
            <div style={{ fontWeight: 500 }}>3. 提交作业</div>
            <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>画作/角色设计提交</div>
          </div>
          <div style={{ padding: 12, background: '#f9f0ff', borderRadius: 8, textAlign: 'center' }}>
            <div style={{ fontSize: 24, marginBottom: 4 }}>🎬</div>
            <div style={{ fontWeight: 500 }}>4. 制作动画</div>
            <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>CMS制作并发放领取码</div>
          </div>
        </div>
      </div>
    </div>
  )
}

const card = { background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }
const th = { padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }
const td = { padding: 12, fontSize: 13 }
const btn = { padding: '6px 12px', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }
